import { MediaPreviewComponent } from '@epicuro-next/ataraxia/media-preview';
import {
  IDynamicBindableValue,
  IDynamicItem,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

export type TypeForItemMediaPreview = MediaPreviewComponent['media'];
export type TypeForItemMediaPreviewInput = {
  media: TypeForItemMediaPreview;
  product: { articleImageUrl: string };
};

export function getItemMediaPreview(
  id: string,
  mediaProvider: IDynamicBindableValue,
  eventHandlers: IDynamicItem['eventHandlers'],
  options: { classes: string[] } = { classes: ['cursor-pointer'] },
) {
  const itemMediaPreview: IDynamicItem = {
    id,
    contentTypeId: 'dynamic-elements-media-preview',
    styles: {
      style: {
        'aspect-ratio': '1/1',
      },
      classes: options.classes,
      variables: {
        '--atx-media-preview-background': '#fff',
      }
    },
    inputs: {
      media: mediaProvider,
    },
    eventHandlers: {
      onClick: eventHandlers?.onClick ?? [],
      onVisibleOnce: eventHandlers?.onVisibleOnce ?? [],
    },
  };

  return itemMediaPreview;
}
